var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subBlock mgt0"}),_c('div',{staticClass:"stepWrap"},[_c('div',{staticClass:"stepTxt"},[_vm._v(" "+_vm._s(_vm.step)+" ")]),_c('h2',{staticClass:"stepTit"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }